<div class="content">
  <app-header></app-header>
  <div class="content_error_area">
    <p *ngIf="isServerError" class="content_error_area_title">Something has gone wrong.</p>
    <p class="content_error_area_text">{{ errorMessage }}</p>
  </div>
</div>
